import React from "react";
import BillRow from "./BillRow/BillRow";
import styles from "./BillList.module.css";

import type {
  BillStatus,
  BillType,
} from "./Bill/Bill";

export interface BillListItem {
  _id: string;
  title: string;
  amount: number;
  grossAmount: number;
  status: BillStatus;
  type: BillType;
  transferTitle: string;
  createdAt?: string;
  paidAt?: string;

  offer?:
    | string
    | {
        companyName?: string;
      };
}

interface BillListProps {
  bills: BillListItem[];
  isAdmin?: boolean;
}

const BillList: React.FC<BillListProps> = ({
  bills,
  isAdmin = false,
}) => {
  if (!bills.length) {
    return (
      <div className={styles.Empty}>
        Brak rachunków do wyświetlenia.
      </div>
    );
  }

  return (
    <div className={styles.List}>
      {bills.map((bill) => (
        <BillRow
          key={bill._id}
          _id={bill._id}
          title={bill.title}
          amount={bill.amount}
          grossAmount={bill.grossAmount}
          status={bill.status}
          billType={bill.type}
          companyName={
            typeof bill.offer === "object"
              ? bill.offer.companyName
              : undefined
          }
          createdAt={bill.createdAt}
          isAdmin={isAdmin}
        />
      ))}
    </div>
  );
};

export default BillList;